module.exports = __webpack_public_path__ + "static/media/breadcrumb03.98b809ea.png";